import {  MFASessionStorageEncryptedOktaUserIdKey, MFA_ENROLL_STATUS, MFA_STATUS } from '../../constants'
import { MFA } from '../mfaWizard/MFASteps'
import UrlBuilder from '../shared/urlBuilder/UrlBuilder'
import { getAskMeLaterLocalStorageValue, setAskMeLaterDataOnLocalStorage } from '../../utils/localStorageUtils'

const IsAskMeLaterPastDate = () => {
    const askMeLaterTime = getAskMeLaterLocalStorageValue()
    const periodOfTime = new Date( askMeLaterTime )
    const currentDate = new Date()        
    return currentDate >=  periodOfTime
}

const IsMfaRequired = ( status ) => {
    return status == MFA_STATUS.MFA_REQUIRED || status == MFA_STATUS.MFA_ENROLL
}

const IsPhoneValid = ( phoneNumber ) => {    
    return ( phoneNumber.length === 12 )
}

const RedirectToReturnUrl = ( returnUrl ) => {    
    location.assign( UrlBuilder( { url: returnUrl, buildURL: false } ) )
}

const RedirectToLogin = ( ) => {
    location.reload( )
}

const AskMeAgainRedirect = ( mfaAskMeAgainTimeOut, returnUrl ) => {
    const askMeAgainHideTime = new Date()
    askMeAgainHideTime.setMinutes( askMeAgainHideTime.getMinutes() + mfaAskMeAgainTimeOut ) 
    setAskMeLaterDataOnLocalStorage( askMeAgainHideTime )
    RedirectToReturnUrl( returnUrl )
}

const TimeOut = async ( ms ) => { 
  return new Promise( resolve => setTimeout( resolve, ms ) )    
}

const IsFactorActive = ( factors, type ) =>{    
   const factor = factors.find( value => value.factorType === type )
   if( !factor ) return false
   return factor.status === MFA_ENROLL_STATUS.ACTIVE
}

const IsEnrolledToAnyFactor = ( factors ) =>{    
   if( !factors ) return false
   const factor = factors.find( value => value.status === 'ACTIVE' )
   if( !factor ) return false
   return factor.id !== null
}

const getEmailFactor = ( factors ) => { 
    const emailFactor = factors.find( value => value.factorType === MFA.factorType.email )
    return emailFactor ? emailFactor.value : ''
 }

 const setActiveFactor = ( factor, factors ) => { 
    const factorType = factor == MFA.FACTORS.EMAIL ? MFA.factorType.email : MFA.factorType.sms
    return factors.map( ( factorValue ) =>  { 
        if ( factorValue.factorType === factorType ) factorValue.status = MFA_ENROLL_STATUS.ACTIVE  
        return factorValue         
    }  ) 
  }

const getOktaEncryptedUserId = () => { 
    return sessionStorage.getItem( MFASessionStorageEncryptedOktaUserIdKey )
}

const setOktaEncryptedUserId = ( encryptedUserId ) => { 
    sessionStorage.setItem( MFASessionStorageEncryptedOktaUserIdKey, encryptedUserId )       
}

export const MFADomain = {
    IsAskMeLaterPastDate,
    IsMfaRequired,
    AskMeAgainRedirect,
    RedirectToReturnUrl,
    IsPhoneValid,
    TimeOut,
    RedirectToLogin,
    IsFactorActive,
    getEmailFactor,
    setActiveFactor,
    getOktaEncryptedUserId,
    setOktaEncryptedUserId,
    IsEnrolledToAnyFactor
}